export { default } from 'flows/core/pages/sign-up/index';
